import { render, staticRenderFns } from "./GAccountTop.vue?vue&type=template&id=6bfd7c0d&scoped=true&"
import script from "./GAccountTop.vue?vue&type=script&lang=ts&"
export * from "./GAccountTop.vue?vue&type=script&lang=ts&"
import style0 from "./GAccountTop.vue?vue&type=style&index=0&id=6bfd7c0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfd7c0d",
  null
  
)

export default component.exports